export const isCartExpired = (timestamp?: number) => {
  const oneHour = 60 * 60 * 1000;
  const currentTime = Date.now();

  return !timestamp || Boolean(currentTime - timestamp > oneHour);
};
